import { useIntl } from '@capsicum/common';
import { useAtom } from 'jotai';

import { ncwTransferRecipientAtom } from '../data-access';

export const useNCWRecipientsList = () => {
	const { $t } = useIntl();
	const intlText = {
		addRecipientLink: $t('ncWallet.send.recipientList.addRecipientLink'),
		addRecipientText: $t('ncWallet.send.recipientList.addRecipientText'),
		buttonText: $t('global.button.continue'),
		title: $t('ncWallet.send.recipientList.title')
	};

	const [selectedRecipient, setSelectedRecipient] = useAtom(ncwTransferRecipientAtom);

	return {
		intlText,
		selectedRecipient,
		setSelectedRecipient
	};
};
